export const INPUT_TYPES = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  CURRENCY: 'CURRENCY',
}

export const CONTROL_TYPES = {
  SINGLE_LINE_TEXT: 'SINGLE_LINE_TEXT',
  NUMBER: 'NUMBER',
  CURRENCY: 'CURRENCY',
  MULTI_LINE_TEXT: 'MULTI_LINE_TEXT',
  DROPDOWN_LIST: 'DROPDOWN_LIST',
  CHECKBOX_LIST: 'CHECKBOX_LIST',
  DATE: 'DATE',
  COUNTRY: 'COUNTRY',
  STATE: 'STATE',
  COMPANY: 'COMPANY',
  EMAIL: 'EMAIL',
  DEAL_VALUE: 'DEAL_VALUE',
}

export const FORMKIT_FORM_RENDERER_KEY = Symbol('FORMKIT_FORM_RENDERER')